import script from "./DetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailsModal.vue?vue&type=script&setup=true&lang=js"

import "./DetailsModal.vue?vue&type=style&index=0&id=ab5c312a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab5c312a"]])

export default __exports__